import Vue from "vue";
import App from "./App.vue";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";

import "./assets/css/styles.css";
import "./assets/js/scripts.js";

Vue.use(VueApexCharts);
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.component("apexchart", VueApexCharts);
new Vue({
  render: (h) => h(App),
}).$mount("#app");
